import { useState } from 'react';
import { X } from 'lucide-react';
import {
  dismissInstallTip,
  isIosDevice,
  shouldShowInstallTip,
} from '@/lib/pwa';

interface Props {
  className?: string;
  /** When true, user can dismiss and we won't show again in the browser. */
  dismissible?: boolean;
}

export function InstallAppTip({ className = '', dismissible = true }: Props) {
  const [visible, setVisible] = useState(shouldShowInstallTip);

  if (!visible) return null;

  const ios = isIosDevice();

  const dismiss = () => {
    dismissInstallTip();
    setVisible(false);
  };

  return (
    <div className={`rounded-xl border border-gold/40 bg-gold/10 p-4 text-left ${className}`}>
      <div className="flex items-start gap-3">
        <img
          src="/icon-192.png"
          alt=""
          width={44}
          height={44}
          className="mt-0.5 h-11 w-11 shrink-0 rounded-[10px] shadow-sm"
          aria-hidden
        />
        <div className="min-w-0 flex-1">
          <div className="font-serif text-sm font-bold text-navy">Add Bag Tag to your home screen</div>
          <p className="mt-1.5 text-xs leading-relaxed text-slate-600">
            {ios ? (
              <>
                In <strong>Safari</strong>, tap <strong>Share</strong> (↑) then{' '}
                <strong>Add to Home Screen</strong>. Bag Tag will open full screen like an app.
              </>
            ) : (
              <>
                In <strong>Chrome</strong>, open the menu (⋮) and choose{' '}
                <strong>Install app</strong> or <strong>Add to Home screen</strong>.
              </>
            )}
          </p>
          <p className="mt-2 text-[11px] italic leading-relaxed text-slate-500">
            Independent app for golf members. Not affiliated with any country club.
          </p>
        </div>
        {dismissible && (
          <button
            type="button"
            onClick={dismiss}
            className="shrink-0 rounded-full p-1 text-slate-400 hover:text-navy"
            aria-label="Dismiss"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
